import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Button } from '@components';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';

import { boPhanGetAllAction } from '@app/store/reducers/boPhan';
import {
    teamGetAllAction,
    teamUpdateAction
} from '@app/store/reducers/team';
import { URI_INTERNAL } from '@app/utils/pathLocations';
import { toast } from 'react-toastify';
import { messageToast } from '@app/utils/define';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const TeamEdit = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const query = useQuery();

    const idParam = query.get('id');
    const id = idParam ? parseInt(idParam, 10) : NaN;

    const { list: boPhanList } = useSelector((state) => state.boPhan);
    const { list: teamList } = useSelector((state) => state.team);

    const [boPhanId, setBoPhanId] = useState('');
    const [name, setName] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (!teamList || teamList.length === 0) {
            dispatch(teamGetAllAction());
        }
        if (!boPhanList || boPhanList.length === 0) {
            dispatch(boPhanGetAllAction());
        }
    }, [dispatch, teamList, boPhanList]);

    useEffect(() => {
        if (!Array.isArray(teamList) || Number.isNaN(id)) return;

        const current = teamList.find((x) => x.id === id);
        if (current) {
            setBoPhanId(String(current.boPhanId));
            setName(current.name || '');
        }
    }, [id, teamList]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (Number.isNaN(id)) {
            toast.error('Thiếu id Team');
            return;
        }

        if (!boPhanId) {
            toast.error('Vui lòng chọn Bộ phận');
            return;
        }

        if (!name.trim()) {
            toast.error('Vui lòng nhập tên Team');
            return;
        }

        const boPhanIdNumber = Number(boPhanId);
        const selectedBoPhan =
            Array.isArray(boPhanList) &&
            boPhanList.find((bp) => bp.id === boPhanIdNumber);

        const model = {
            boPhanId: boPhanIdNumber,
            name: name.trim(),
            boPhanName: selectedBoPhan ? selectedBoPhan.tenBoPhan : undefined
        };

        try {
            setIsSubmitting(true);

            await dispatch(
                teamUpdateAction({ id, data: model })
            ).unwrap();

            toast.success(messageToast.messageToastUpdateSuccess);
            history.push(URI_INTERNAL.TEAM_PATH);
        } catch (err) {
            console.error('Cập nhật Team lỗi:', err);

            let msg =
                (err && err.message) ||
                (typeof err === 'string' ? err : '') ||
                (err && err.title) ||
                '';

            if (!msg && err && err.errors) {
                msg = Object.values(err.errors).flat().join('; ');
            }

            toast.error(
                msg
                    ? `${messageToast.messageToastUpdateError}: ${msg}`
                    : messageToast.messageToastUpdateError
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        history.push(URI_INTERNAL.TEAM_PATH);
    };

    if (Number.isNaN(id)) {
        return (
            <Card>
                <Card.Header as="h5">Sửa Team</Card.Header>
                <Card.Body>Thiếu id Team</Card.Body>
            </Card>
        );
    }

    return (
        <Card>
            <Card.Header as="h5">Sửa Team</Card.Header>
            <Card.Body>
                <Form noValidate onSubmit={handleSubmit}>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label className="col-sm-2 col-form-label">
                            Bộ phận
                        </Form.Label>
                        <Col sm="10">
                            <Form.Control
                                as="select"
                                value={boPhanId}
                                onChange={(e) => setBoPhanId(e.target.value)}
                                required
                            >
                                <option value="">-- Chọn Bộ phận --</option>
                                {boPhanList &&
                                    boPhanList.map((bp) => (
                                        <option key={bp.id} value={bp.id}>
                                            {bp.tenBoPhan}
                                        </option>
                                    ))}
                            </Form.Control>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Form.Label className="col-sm-2 col-form-label">
                            Tên Team
                        </Form.Label>
                        <Col sm="10">
                            <Form.Control
                                placeholder="Tên Team"
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Col md={{ span: 10, offset: 2 }}>
                            <ButtonGroup>
                                <Button
                                    type="submit"
                                    theme="primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Đang lưu...' : 'Lưu'}
                                </Button>
                                &nbsp;&nbsp;&nbsp;
                                <Button
                                    type="button"
                                    theme="secondary"
                                    onClick={handleCancel}
                                    disabled={isSubmitting}
                                >
                                    Hủy
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Form.Group>
                </Form>

                <ReactSpinner loadings={isSubmitting} />
            </Card.Body>
        </Card>
    );
};

export default TeamEdit;
